import { call, put, takeLatest } from 'redux-saga/effects';
import ApiRouts from '../../api/routes';
import {GET} from "../../api";
import {FETCH_LATEST_VERSION, SET_LATEST_VERSION} from "../actions";

export function* FetchLatestVersionSaga() {
    try {

        const response = yield call(GET, ApiRouts.API_LATEST_VERSION , {});

        if (response) {

            yield put({
                type:SET_LATEST_VERSION,
                payload:response.data.data
            });
        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {
        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* versionSaga() {
    yield takeLatest(FETCH_LATEST_VERSION, FetchLatestVersionSaga);
    // yield takeLatest(SET_LATEST_VERSION, setLatestVersion);
}

export default versionSaga;
